'use client';

import { useQuery, api } from '@/lib/convex';
import { useConvexAuth } from 'convex/react';
import { useEffect, useState } from 'react';

export const AUTH_VIEWER_SYNC_GRACE_MS = 8_000;

export function useAuth() {
  const {
    isAuthenticated: isConvexAuthenticated,
    isLoading: isConvexAuthLoading,
  } = useConvexAuth();
  const {
    data: user,
    isPending,
    isError,
  } = useQuery(api.users.queries.viewer, isConvexAuthenticated ? {} : 'skip');
  const viewerMissing =
    isConvexAuthenticated && !isPending && !isError && user === null;
  const [viewerSyncTimedOut, setViewerSyncTimedOut] = useState(false);

  useEffect(() => {
    const timeoutId = window.setTimeout(
      () => setViewerSyncTimedOut(viewerMissing),
      viewerMissing ? AUTH_VIEWER_SYNC_GRACE_MS : 0
    );
    return () => window.clearTimeout(timeoutId);
  }, [viewerMissing]);

  const isLoading =
    isConvexAuthLoading ||
    (isConvexAuthenticated &&
      (isPending || (user === null && !viewerSyncTimedOut)));

  return {
    user,
    isLoading,
    isSignedOut: !isConvexAuthLoading && !isConvexAuthenticated,
    isAuthenticated:
      isConvexAuthenticated && !isLoading && !isError && user !== null,
  };
}
